module.exports = __webpack_public_path__ + "img/proList2_22.c5071213.jpg";